





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { AlertOptions } from './AlertOptions';
import { Alert } from './Alert';

@Component({ name: 'alert' })
export default class AlertComponent extends Vue {
  @Prop() public options!: AlertOptions | undefined;

  public queue: Alert[] = [];
  public alert: Alert | null = null;
  public maxTime = 4000;
  public timer = 0;

  public get percent(): number { return (this.timer / this.maxTime) * 100; }

  public addAlert(alert: Alert) {
    if (this.alert === null) {
      this.startAlert(alert);
    } else {
      this.queue.push(alert);
    }
  }

  public getNext() {
    const newAlert = this.queue.shift();
    if (newAlert !== undefined) {
      this.startAlert(newAlert);
    }
  }

  public startAlert(alert: Alert) {
    this.alert = alert;
    this.timer = this.maxTime;

    let time = new Date() as any;
    const loop = () => {
      const cur = new Date() as any;
      this.timer -= cur - time;

      if (this.timer > 0) {
        time = cur;
        requestAnimationFrame(loop);
      } else {
        this.alert = null;
      }
    }

    requestAnimationFrame(loop);
  }
}
